import { render, staticRenderFns } from "./dataReference.vue?vue&type=template&id=9af420ea"
import script from "./dataReference.vue?vue&type=script&lang=js"
export * from "./dataReference.vue?vue&type=script&lang=js"
import style0 from "./dataReference.vue?vue&type=style&index=0&id=9af420ea&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_21c2e229d51f918cc63b499183bc63cd/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports